import { render, staticRenderFns } from "./DragContainer.vue?vue&type=template&id=fb44dcf0&scoped=true&"
import script from "./DragContainer.vue?vue&type=script&lang=js&"
export * from "./DragContainer.vue?vue&type=script&lang=js&"
import style0 from "./DragContainer.vue?vue&type=style&index=0&id=fb44dcf0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb44dcf0",
  null
  
)

export default component.exports